import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { DBO_REQ } from '@op/utils/format';
import { TRequestBackType } from '@op/utils/requestUtil';
import { getMemeTrendTimeline } from '@opm/services';
import { useEffect, useState } from 'react';

export function useMemeTrend({ filter }: { filter: any }) {
  const [data, setData] = useState<TRequestBackType>({
    isEmpty: true,
  });
  const { wrapperCancelRequest, loading } = useCancelRequestHook<TRequestBackType>({defaultLoading: true});

  function request() {
    if (!filter?.meme_title) return;
    wrapperCancelRequest(getMemeTrendTimeline, filter)
      .then((res: any) => {
        const { timeline, timeline_of_time: timeOfTime } = res || {};
        const chartData = DBO_REQ.moreKeys({
          timeline,
          timeline_of_start_time: timeOfTime?.timeline_of_start_time,
          timeline_of_end_time: timeOfTime?.timeline_of_end_time,
          fixedKeyList: ['views', 'publications'],
          needTable: true,
          moreLineTable: true,
          filter,
        });
        setData({ ...chartData, ...res });
      })
      .catch(() => {});
  }

  useEffect(() => {
    request();
  }, [filter]);

  return {
    data,
    loading,
  };
}
